import { date } from 'quasar'
import Model, { encoders, ID, IsoDateTime } from 'src/models/model'
import Order from 'src/models/order/Order'
import Showing from 'src/models/showing/Showing'
import TicketType from 'src/models/showing/TicketType'
import User from 'src/models/user/User'

export default class Ticket extends Model {
  static name = 'Ticket'

  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true,
        sortable: true
      },
      state: {
        type: String,
        output: true,
        default: 'draft',
        sortable: true
      },
      showing: {
        type: Showing,
        encode: encoders.hasOne,
        reference: true
      },
      ticket: {
        type: Ticket,
        default: null,
        output: true,
        reference: true
      },
      tickets: {
        type: [Ticket],
        default: () => ([]),
        acceptsNestedAttributes: true,
        allowDestroy: true
      },
      ticketType: {
        type: TicketType,
        encode: encoders.hasOne,
        reference: true
      },
      ticketNumber: {
        type: String,
        output: true
      },
      user: {
        type: User,
        encode: encoders.hasOne,
        reference: true,
        default: null
      },
      price: {
        type: Number,
        output: true,
        default: null,
        computed () {
          if (this.state !== 'draft') return this.data.price

          return this.finalTicketType?.price
        }
      },
      seatName: {
        type: String,
        required: false,
        sortable: true
      },
      originalSeatName: {
        type: String,
        output: true
      },
      order: {
        type: Order,
        reference: true,
        output: true
      },
      admittedAt: {
        type: IsoDateTime,
        output: true
      }
    }

    this.computed = {
      finalTicketType () {
        const priceCardItems = this.showing?.priceCard?.priceCardItems?.data || []
        const priceCardItem = _.find(priceCardItems, priceCardItem => priceCardItem.ticketType?.id === this.ticketType.id)

        if (priceCardItem && priceCardItem.hasCustomPrice) {
          // CLONE THE TICKET TYPE AND OVERRIDE THE PRICE
          const clone = priceCardItem.ticketType.clone()
          clone.price = priceCardItem.customPrice

          const prices = {
            price: clone.price
          }
          clone.destroy()
          return prices
        }

        return { price: this.ticketType.price }
      },
      isVoided () {
        return this.state === 'voided'
      },
      name () {
        return this.user?.name || this.order?.name || 'Anonymous'
      }
    }

    this.watchers = [
      [
        function () { return this.seatName },
        async function () {
          _.each(this.tickets.data, marathonTicket => {
            marathonTicket.seatName = this.seatName
          })
        }
      ]
    ]

    this.paginate = true
  }

  get title () {
    return `${this.member.name}`
  }

  get description () {
    return `${this.showing.movie.name} at ${date.formatDate(this.showing.time, 'h:mm a')}`
  }

  assignSeatName (seatName) {
    this.seatName = seatName
  }

  removeSeatName () {
    this.seatName = undefined
  }
}
